// 加工実績取得
import { AnyAction, Dispatch } from "redux";
import apiAxios from '../utils/apiAxios';
import { FlattenedObject } from '../models/Po';
import { createSlice} from '@reduxjs/toolkit';
import { flattenPoData } from '../utils/utils';

type MachResults = {
  values : FlattenedObject[];
}
// 初期値
const initialState: MachResults = {
  values : [],
}
export const machResultSlice = createSlice({
  name: 'machResults',
  initialState,
  reducers: {
    setRowData: (state, {type, payload}) => {
      state.values = payload;
    },
  },
});
// アクションの切り出し
const {setRowData} = machResultSlice.actions;

const toQueryString = (po_desc_num:string, proc_code?:string,  mach_code?:string ) => {
  const urlParams = new URLSearchParams();
  // 加工コード 
  if(proc_code) {
    urlParams.append("proc_code", proc_code);
  }
  // 機械コード
  if(mach_code) {
    urlParams.append("mach_code", mach_code);
  }
  // 受注No
  urlParams.append("po_desc_num", po_desc_num);
  return urlParams.toString();
};

// 加工実績の取得
const fetchProcResult = (po_desc_num:string, proc_code?:string, mach_code?:string ) => {
  const param = toQueryString(po_desc_num, proc_code, mach_code) ;
  return async (dispatch:Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get(`/proc_list?${param}`);
      const data = response.data;
      let holiday:string[] = [];
      if (data !== null) {
        let flattenedData = flattenPoData(data, holiday);
        dispatch(setRowData(flattenedData));
        return flattenedData;
      } else {
        dispatch(setRowData([]));
        return [];
      }
    } catch (error:any) {
      console.error(error);
    }
  }
}

export {setRowData, fetchProcResult }
export default machResultSlice.reducer;